module.exports = __webpack_public_path__ + "static/media/adults-agenda-cafe-1056551.137d26cd.jpg";